export default "__VITE_PUBLIC_ASSET__172b4b5f__"